const queryKeys = {
  auth: { user: 'user-auth' },
  cortex: { organizationInsights: 'cortex-organization-insights' },
  growthZone: {
    goals: 'goals',
    newGoal: 'new-goal',
    completeGoal: 'complete-goal',
    editGoal: 'edit-goal',
  },
  user: {
    info: 'user-info',
    dashboard: 'user-dashboard',
    notificationPreferences: 'user-notification-preferences',
  },
  organization: {
    members: 'org-members',
    dashboard: 'org-dashboard',
    activeContract: 'org-active-contract',
    teamConcerns: 'org-team-concerns',
    events: {
      contact: 'org-event-contact',
    },
    report: 'org-report',
  },
  peerSupport: {
    dashboard: 'peer-support-dashboard',
    engagement: 'peer-support-engagement',
    members: 'peer-support-members',
  },
  providers: {
    directory: 'providers-directory',
    byId: 'provider-by-id',
    timeSlots: 'provider-time-slots',
  },
  legal: {
    privacyPolicy: 'legal-privacy-policy',
    termsOfUse: 'legal-terms-of-use',
    contentPolicy: 'legal-content-policy',
  },
  documents: {
    screener: 'screener-documents',
  },
  memberCare: {
    myOrganizationMemberCares: 'member-care-my-organization-member-cares',
    memberCareById: 'member-care-by-id',
  },
  notes: {
    self: 'notes-self',
  },
  timeline: {
    self: 'timeline-self',
  },
  notifications: {
    latest: 'notifications-latest',
    infinite: 'notifications-infinite',
    unreadCount: 'notifications-unread-count',
    toggleReadSingle: 'notification-read-single',
    toggleReadMultiple: 'notification-read-multiple',
    sendScreenerReminder: 'notification-send-screener-reminder',
  },
  screener: {
    domainInterpretation: 'screener-domain-interpretation',
    subdomainInterpretation: 'screener-subdomain-interpretation',
  },
  publicScreener: {
    checkOrg: 'check-org',
    validateOrg: 'validate-org',
    getResults: 'screener-results',
    orgAverageScore: 'org-average-score',
  },
  meta: {
    USStates: 'meta-us-states',
  },
  content: {
    all: 'content-all',
    mine: 'content-mine',
    byId: 'content-by-id',
    feed: 'content-feed',
    author: 'content-author',
    // One key per feed-algorithm surface so their caches never collide — the ranked
    // feed rotates per draw while filtered/search are deterministic, so sharing a key
    // would let a deterministic result overwrite a ranked draw (and vice versa).
    personalizedFeed: 'content-personalized-feed',
    filtered: 'content-filtered',
    filterOptions: 'content-filter-options',
    search: 'content-search',
    focusedFeed: 'content-focused-feed',
    saved: 'content-saved',
  },
  contentCreatorApplications: {
    me: 'content-creator-application-me',
    publicMe: 'content-creator-application-public-me',
  },
};

export default queryKeys;
